import { useState } from 'react'
import { Link } from 'react-router-dom'
import { consentStatus, grantConsent, denyConsent } from '../lib/analytics'

/**
 * GDPR consent banner. Analytics (PostHog + Umami) stay off until the user
 * opts in; auth/session cookies are strictly necessary and unaffected.
 * Respects Do Not Track (treated as an implicit "deny", no banner shown).
 * z-[45]: above the header and feedback button (z-40), below modals (z-50),
 * so a modal's buttons are never covered on a first visit.
 */
export default function CookieConsent() {
  const [visible, setVisible] = useState(() => consentStatus() === null)

  if (!visible) return null

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-sm z-[45] card-brutal bg-surface p-4 shadow-brutal"
      data-testid="cookie-consent"
    >
      <p className="text-sm text-ink-muted leading-relaxed mb-3">
        We use anonymous, EU-hosted analytics to understand which features help people decide better.
        No ads, no selling data.{' '}
        <Link to="/privacy" className="text-primary-ink font-bold underline underline-offset-2">Privacy policy</Link>
      </p>
      <div className="flex items-center gap-2">
        <button
          onClick={() => { grantConsent(); setVisible(false) }}
          data-testid="consent-accept-btn"
          className="px-4 py-2 rounded-xl bg-primary text-white font-bold text-sm border-2 border-edge shadow-brutal-sm hover:-translate-y-0.5 hover:shadow-brutal transition-all"
        >
          Allow analytics
        </button>
        <button
          onClick={() => { denyConsent(); setVisible(false) }}
          data-testid="consent-decline-btn"
          className="px-4 py-2 rounded-xl font-bold text-sm border-2 border-edge bg-surface hover:bg-muted transition-all"
        >
          No thanks
        </button>
      </div>
    </div>
  )
}
